module.exports = __webpack_public_path__ + "static/media/W5_1200F_mesh.3486224f.svg";